import React from "react";

import { IconBrandDiscordFilled, IconLifebuoy, IconMail, IconMap2, IconQuestionMark, IconSpeakerphone } from "../icons";
import { DropdownActionItem, DropdownLinkItem, DropdownMenu, DropdownSeparator } from "./DropdownMenu";

const newsLink = "https://operately.com/releases";
const roadmap = "https://operately.com/roadmap";

export function HelpDropdown({
  contactUsHref,
  discordUrl,
  onOpenKeyboardShortcuts,
}: {
  contactUsHref: string;
  discordUrl: string;
  onOpenKeyboardShortcuts: () => void;
}) {
  return (
    <DropdownMenu
      testId="help-dropdown"
      name="Помощь"
      icon={IconLifebuoy}
      align="center"
      minWidth={220}
      triggerClassName="hidden lg:flex"
    >
      <DropdownActionItem
        icon={IconQuestionMark}
        title="Горячие клавиши"
        onClick={onOpenKeyboardShortcuts}
        testId="keyboard-shortcuts-menu-item"
      />
      <DropdownSeparator />
      <DropdownLinkItem path={contactUsHref} icon={IconMail} title="Свяжись с нами" />
      <DropdownLinkItem path={discordUrl} icon={IconBrandDiscordFilled} title="Чат в Discord" target="_blank" />
      <DropdownLinkItem path={newsLink} icon={IconSpeakerphone} title="Что нового" target="_blank" />
      <DropdownLinkItem path={roadmap} icon={IconMap2} title="Дорожная карта" target="_blank" />
    </DropdownMenu>
  );
}
